export const openSearchEvent = 'qs:open-search';
